module.exports = __webpack_public_path__ + "bed69f1792a621689fbc55ed26dd66be.png";